import { Integration } from 'signup-constants/Integration';
import { isIntegration } from './isIntegration';
export const isIntegratedApp = () => {
  return isIntegration(Integration.Wordpress) || isIntegration(Integration.ShopifyEmbedded) || isIntegration(Integration.GoogleWorkspaceApp);
};
export const isIntegratedAppCookielessBranch = queryParamsMap => {
  return queryParamsMap.get('cookielessWordpress') === '1' || queryParamsMap.get('cookieless') === '1';
};